// Wat er de voorbije dagen beslist is — voor Alex en Matti.
//
// ── WHY THIS IS A SCREEN AND NOT ONLY A PANEL SECTION ───────────────────────────
// The per-task history answers "why is this task like this". The questions a planner actually asks at
// the end of a week cross tasks: what did Matti change on Wilgenstraat, what got moved out of last
// week, who keeps being swapped off ventilation. None of those fit inside one workpackage.
//
// It reads the same log and phrases it the same way. Nothing is analysed, ranked or suggested — the
// screen shows what people did, in the order they did it.
import { useQuery } from '@tanstack/react-query';
import * as A from '../api/planning.ts';
import { keys } from '../lib/mutate.ts';
import { History } from '../ui/History.tsx';

export function HistoryScreen() {
  const people = useQuery({ queryKey: keys.people, queryFn: A.listPeople, staleTime: 60_000 });
  const projects = useQuery({ queryKey: keys.projects, queryFn: A.listProjects, staleTime: 60_000 });
  return (
    <div className="stack">
      <div className="card stack">
        <div>
          <strong>Historie</strong>
          <p className="faint" style={{ margin: '4px 0 0' }}>
            Wat Alex en Matti gewijzigd hebben. Alleen jullie zien dit scherm.
          </p>
        </div>
        <History filters={{ people: people.data ?? [], projects: projects.data ?? [] }} />
      </div>
    </div>
  );
}
